import React from 'react';
import './OutputMetrics.css';

function OutputMetrics({ data }) {
    const metrics = [
        {
            label: 'Offer → Hire Acceptance Rate',
            value: `${(data?.offerToHireAcceptanceRate || 0).toFixed(1)}%`,
            color: '#10b981',
            type: 'percentage'
        },
        {
            label: 'Total Hires',
            value: data?.totalHires || 0,
            color: '#3b82f6',
            type: 'count'
        },
        {
            label: 'Onboarding No-Shows',
            value: data?.onboardingNoShows || 0,
            color: '#ef4444',
            type: 'count'
        }
    ];

    return (
        <div className="output-metrics-container">
            <h2 className="output-metrics-title">Output Metrics</h2>
            <div className="output-metrics-grid">
                {metrics.map((metric, index) => (
                    <div
                        key={index}
                        className="output-metric-card"
                        style={{ borderTopColor: metric.color }}
                    >
                        <div
                            className="output-metric-value"
                            style={{ color: metric.color }}
                        >
                            {metric.value}
                        </div>
                        <div className="output-metric-label">{metric.label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default OutputMetrics;
